import React, { useState, useContext } from 'react'
import {
	Button, Modal, ModalHeader, ModalBody, ModalFooter,
	FormGroup, Label, Input, Alert
} from 'reactstrap'
import { SessionContext } from '../../contexts/SessionProvider'
import AuctionTabsService from '../../services/AuctionTabsService'

/**
 * Modal for moving an unsold vehicle to Shipping status.
 * BRD: Manual action to mark vehicle as shipped to physical auction.
 */
const MoveToShippingModal = ({ isOpen, toggle, auction, onSuccess }) => {
	const { sessionKey } = useContext(SessionContext)
	const [notes, setNotes] = useState('')
	const [isSubmitting, setIsSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const handleSubmit = async () => {
		setIsSubmitting(true)
		setError(null)

		try {
			await AuctionTabsService.moveToShipping(auction?.auctionId, notes, sessionKey)
			setNotes('')
			onSuccess?.()
			toggle()
		} catch (err) {
			setError(err.response?.data?.message || 'Failed to move vehicle to shipping.')
		} finally {
			setIsSubmitting(false)
		}
	}

	const handleClose = () => {
		setNotes('')
		setError(null)
		toggle()
	}

	if (!auction) return null

	return (
		<Modal isOpen={isOpen} toggle={handleClose} centered>
			<ModalHeader toggle={handleClose}>
				Move to Shipping
			</ModalHeader>
			<ModalBody>
				{error && <Alert color="danger">{error}</Alert>}
				
				<p>
					You are about to mark this vehicle as shipped to physical auction:
				</p>
				<div className="bg-light p-3 rounded mb-3">
					<strong>{auction.year} {auction.make} {auction.model}</strong>
					<br />
					<small className="text-muted">VIN: {auction.vin}</small>
					{auction.stockNumber && (
						<>
							<br />
							<small className="text-muted">Stock #: {auction.stockNumber}</small>
						</>
					)}
				</div>
				
				<FormGroup>
					<Label for="shippingNotes">Notes (Optional)</Label>
					<Input
						type="textarea"
						id="shippingNotes"
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
						placeholder="Enter any notes about the shipment..."
						rows={3}
					/>
				</FormGroup>
				
				<Alert color="info" className="mb-0">
					<small>
						<strong>Note:</strong> This will update the vehicle status to "Shipping". 
						The vehicle can then be moved to Physical Auction upon arrival.
					</small>
				</Alert>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={handleClose} disabled={isSubmitting}>
					Cancel
				</Button>
				<Button color="primary" onClick={handleSubmit} disabled={isSubmitting}>
					{isSubmitting ? 'Processing...' : 'Move to Shipping'}
				</Button>
			</ModalFooter>
		</Modal>
	)
}

export default MoveToShippingModal
